<app-modal [header]="'header.options.complex_article_rules' | translate">
  <div modal-body class="h-100">
    <div class="d-flex gap-4">
      <app-complex-article-blueprint-list (update)="reValidate(blueprint())" #listComponent [(selected)]="blueprint"/>
      <div class="">
        <div class="d-flex flex-column gap-2 h-100 overflow-y-auto" style="width: 350px; max-height: calc(100dvh - 230px)">
          @if (blueprint(); as blueprint) {
            <b class="d-block mb-2">{{ 'complexArticleBlueprint.label.run' | translate }}</b>
            <p><b class="d-block mb-2">{{ blueprint.name }}: </b>{{blueprint.description}}</p>
            <div>
              <label for="versionOverwriteMode" class="form-label">{{ 'complexArticleBlueprint.label.version_mode' | translate }}</label>
              <select id="versionOverwriteMode" [value]="'only-new-articles'" [(ngModel)]="versionOverwriteMode" class="form-control">
                <option value="new-version">{{ 'complexArticleBlueprint.label.new_version' | translate }}</option>
                <option value="only-new-articles">{{ 'complexArticleBlueprint.label.only_new-articles' | translate }}</option>
                <option value="overwrite-latest-version">{{ 'complexArticleBlueprint.label.overwrite_last-version' | translate }}</option>
              </select>
            </div>

            <div class="form-check">
              <input [(ngModel)]="isInternal" type="checkbox" class="form-check-input" name="internal" id="internal">
              <label class="form-check-label" for="internal">{{ 'complexArticleBlueprint.label.internal' | translate }}</label>
            </div>

            <div class="form-check">
              <input [(ngModel)]="isNotSearchable" type="checkbox" class="form-check-input" name="notSearchable" id="notSearchable">
              <label class="form-check-label" for="notSearchable">{{ 'complexArticleBlueprint.label.not_searchable' | translate }}</label>
            </div>

            @let validationErrorsValue = validationErrors();
            <button [disabled]="!validationErrorsValue.valid" id="run" class="btn btn-primary mt-3" (click)="execute()">{{ 'complexArticleBlueprint.label.run' | translate }}</button>

            <div class="d-flex flex-column justify-content-between">
              @if (!validationErrorsValue.valid) {
                <div class="alert alert-warning" style="white-space: pre-line">{{ validationErrorsValue.errorsText }}</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <ng-container modal-footer>
    <button class="btn btn-secondary btn-cancel" type="button" (click)="close()">{{ 'global.label.close' | translate }}</button>
  </ng-container>
</app-modal>
